import { IContract } from "v2/pages/Workspace/WorkspaceListContracts/ListContracts/ListContracts.types";

/**
 * O nome do contrato no seletor do Insights: produto, operadora e número.
 * Separador "·", sem travessão (doc 16 da camada de apresentação; a prova em
 * browser de 25/09 viu "Saúde — HapVida — #8LL3M").
 */
export function contractLabel(
  contract: Pick<IContract, "product" | "supplierCorporateName" | "policyContractNumber">
): string {
  return [
    contract.product?.name,
    contract.supplierCorporateName,
    contract.policyContractNumber ? `#${contract.policyContractNumber}` : null,
  ]
    .filter(Boolean)
    .join(" · ");
}
